import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { MenuItem } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MenuService } from '../../../core/services/menu.service';

@Component({
  selector: 'sigv-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
})
export class SideMenuComponent implements OnInit, AfterViewInit, OnDestroy {
  isVisible: boolean;
  items: MenuItem[];
  private readonly destroy$ = new Subject();

  constructor(private logger: NGXLogger, private menuService: MenuService) {
    this.isVisible = true;
    this.items = [];
  }

  ngOnInit(): void {
    this.menuService
      .getSideMenuObservable()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (isOpen) => {
          this.isVisible = isOpen;
        },
        error: (err) => this.logger.error(err),
      });

    this.menuService
      .getMenuItemsObservable()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (menus) => {
          this.items = menus;
        },
        error: (err) => this.logger.error(err),
      });
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
